import React from "react";

const Footer = () => {
  return (
    <div id="footer">
      <div className="container text-center">
        <p>
          &copy; All Rights Reserved - ESSI Security and Defence{" "}
          <a href="https://www.essi.co.in" rel="nofollow">
            essi.co.in
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
